import React, {useEffect, useState} from "react";
import "./RaikoImageCropper.scss";
import MainImageCropper from "./mainImageCropper/MainImageCropper";
import thumbnail from "../../assets/images/header/avatar_man.jpg"
import loadingAnim from "../../assets/lottie/loading.json";
import {Player} from "@lottiefiles/react-lottie-player";
import {DialogSize, RaikoDefaultDialogPage, RaikoGridOneColumn} from "@moeindal/base-raiko-panel-components";
import ImageProxyHelper from "../../util/ImageProxyHelper"

export default function RaikoImageCropper(
    {
        updateAvatar,
        avatarFile,
        loading = false
    }) {

    const [avatarUrl, setAvatarUrl] = useState("");
    const ASPECT_RATIO = 1;

    useEffect(() => {
        if (typeof avatarFile !== 'undefined') {
            setAvatarUrl(
                new ImageProxyHelper.Builder(avatarFile.toString().replaceAll('http:', 'https:'))
                    .changeQuality(80)
                    .setImageCompressSize(100, 100)
                    .build()
            )
            handleCloseChooseFile()
        }
    }, [avatarFile]);

    const [openChooseFile, setOpenChooseFile] = useState(false)

    function handleOpenChooseFile() {
        setOpenChooseFile(true)
    }

    function handleCloseChooseFile() {
        setOpenChooseFile(false)
    }

    return (

        <>
            <RaikoDefaultDialogPage
                onClose={handleCloseChooseFile}
                open={openChooseFile}
                pageTitle={"انتخاب عکس"}
                dialogSize={DialogSize.WRAP_CONTENT}
            >
                <MainImageCropper updateAvatar={updateAvatar} ASPECT_RATIO={ASPECT_RATIO}/>
            </RaikoDefaultDialogPage>
            <RaikoGridOneColumn>
                <div className={"raikoImageCropperLayout"}>
                    {
                        loading ?
                            <div className={"mainImageCropped"}>
                                <Player
                                    src={loadingAnim}
                                    loop
                                    autoplay
                                    style={{height: '100px', width: '100px'}}
                                />
                            </div> :
                            <img
                                src={avatarUrl && avatarUrl.length > 0 ? avatarUrl : thumbnail}
                                alt="thumbnail"
                                className={"mainImageCropped"}
                            />
                    }
                    <button className={"penButtonMainStyle"}
                            onClick={handleOpenChooseFile}
                    >
                        <div className="ic-pen"/>
                    </button>

                </div>
            </RaikoGridOneColumn>
        </>

    )
}